import { Button } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { parseHtmlToReact } from '@payaca/utilities/htmlUtilities';
import { FC, useState } from 'react';

export interface IProps {
  html: string;
  className?: string;
}

const TruncatedHtml: FC<IProps> = (props) => {
  const { html, className } = props;
  const [isShowingMoreHTML, setIsShowingMoreHTML] = useState(false);

  return (
    <>
      <div
        className={clstx(
          isShowingMoreHTML
            ? ''
            : `container-bottom-shadow relative max-h-[100px] overflow-hidden`,
          className || ''
        )}
      >
        {parseHtmlToReact(html)}
      </div>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          setIsShowingMoreHTML((s) => !s);
        }}
        variant={'link-inline'}
        size={'sm'}
      >
        {isShowingMoreHTML ? 'Show less' : 'Show more'}
      </Button>
    </>
  );
};

export default TruncatedHtml;
